module.exports = __webpack_public_path__ + "b015bbef9c5e0ea871c7369436e2093c.pdf";